export default theme => ({
  layerMenu: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-end',
    backgroundColor: '#eee',
    height: '100%',
    padding: 0,
  },
});
